export default __webpack_public_path__ + "static/O0318-64d5b6465cee892f01dc085674df03e4.png";